export default [
    {
        component: () => import(/* webpackChunkName: 'web-service-almoxarifado-cliente-material' */ '@/views/web-service/almoxarifado/cliente/material/Index'),
        path: 'almoxarifado-cliente-material',
        redirect: 'almoxarifado-cliente-material/index',
        children: [
            {
                component: () => import(/* webpackChunkName: 'web-service-almoxarifado-cliente-material' */'@/views/web-service/almoxarifado/cliente/material/List.vue'),
                name: 'web-service-almoxarifado-cliente-material-index',
                path: 'index',
            },
            {
                component: () => import(/* webpackChunkName: 'web-service-almoxarifado-cliente-material' */ '@/views/web-service/almoxarifado/cliente/material/Form.vue'),
                name: 'web-service-almoxarifado-cliente-material-create',
                path: 'create',
            },
            {
                component: () => import(/* webpackChunkName: 'web-service-almoxarifado-cliente-material' */ '@/views/web-service/almoxarifado/cliente/material/Form.vue'),
                name: 'web-service-almoxarifado-cliente-material-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
            },
        ],
    },
]